import React, { useCallback, useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import "./App.css";
// import little_image from "./Little Logo.png";
import little_image from "./Little_Logo150.png";
import Modal from "./ReviewPage";
import { GoLocation } from "react-icons/go";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FiUpload } from "react-icons/fi";
import { BsEyeFill } from "react-icons/bs";
import loadingGif from "./loading-gif.gif";

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Address from "./Address";
import useHttp from "./use-http/use-http";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import BulkUpload from "./BulkUpload/BulkUpload";
import ModeToggle from "./components/ModeToggle";
import {select } from "@mui/material";
import Select from "react-select";

//http://localhost:3000/?type=sc&corpId=1232323&name=allen
const defaultState = {
  schoolNameError: "",
  studentFirstNameError: "",
  studentLastNameError: "",
  studentClassError: "",
  studentPhotoError: "",
  parentFirstNameError: "",
  parentLastNameError: "",
  parentMobileNumberError: "",
  parentEmailError: "",
  addressError: "",
  areaError: "",
  cityError: "",
  pickupStopError: "",
  dropStopError: "",
};

let img;
let img_placeHolder = "Passport Size photo";
let valid = true;
let studentpickupAddress;
let studentdropAddress;
let pickupLatLng;
let dropLatLng;
let riderData;
let corpName = new URLSearchParams(window.location.search)?.get("name");
let corpId = new URLSearchParams(window.location.search)?.get("corpId");

// Debug URL parameters extraction
console.log('🔍 URL Parameters extracted:', {
  corpId,
  corpName,
  url: window.location.href
});
// let type = "sc";
let edit = new URLSearchParams(window.location.search)?.get("edit");
let editType = new URLSearchParams(window.location.search)?.get("type"); // Get type from URL for edit mode
let qrcode = new URLSearchParams(window.location.search)?.get("qcode");
let editFirstName = new URLSearchParams(window.location.search)?.get("firstName");
let editLastName = new URLSearchParams(window.location.search)?.get("lastName");
let bulk = new URLSearchParams(window.location.search)?.get("bulk");
let staffImg = "";
let editPageImgFlag = 1;
function App() {
  const formRef = useRef();
  const schoolNameRef = useRef();
  const studentFirstNameRef = useRef();
  const studentLastNameRef = useRef();
  const studentPhotoRef = useRef();
  const studentClassRef = useRef();
  const parentFirstNameRef = useRef();
  const parentLastNameRef = useRef();
  const parentMobileNumberRef = useRef();
  const parentEmailRef = useRef();
  const addressRef = useRef();
  const cityInputRef = useRef();
  const areaInputRef = useRef();

  const cropperRef = useRef(null);

  const [error, setError] = useState(defaultState);
  const [formIsValid, setFormIsValid] = useState();
  const [stops, setStops] = useState([]);


  const [isRender, setIsRender] = useState();
  const [countryCode, setCountryCode] = useState("254");
  // Set initial type from URL parameter in edit mode, or default to "Student"
  const [type, setType] = useState(editType ? (editType.toLowerCase() === "student" ? "Student" : "Employee") : "Student");
  const [showRadioButtons, setShowRadioButtons] = useState(true);
  const [val, setVal] = useState();
  const [myImg, setMyImg] = useState();
  const [isStaffDetailApiCall, setIsStaffDetailApiCall] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [pickupLocationValid, setPickupLocationValid] = useState(false);
  const [dropLocationValid, setDropLocationValid] = useState(false);

  useEffect(() => {
    if (type?.toLowerCase() !== "Student") {
      const mainElement = document.getElementsByTagName("main")[0];
      if (mainElement) {
        mainElement.style.height = "90%";
      }
    }
  }, [type]);

  const corporateStopDetails = (data) => {
    let temp = [];
    temp.push({ StopName: "Custom" });
    if (data.ShuttleStopList) {
      let activeStops = data.ShuttleStopList.filter(
        (st) => st.IsActive === true
      );
      temp.push(...activeStops);
      setStops(temp);
    }

    // In edit mode, don't override the type - it's already set from the record being edited
    if (edit) {
      setShowRadioButtons(false); // Hide radio buttons in edit mode
      setIsStaffDetailApiCall(true);
      return;
    }

    // Only configure UI based on corporate settings in non-edit mode
    if (data.ShuttleFor) {
      const roles = data.ShuttleFor.split(",").map((role) =>
        role.trim().toLowerCase()
      );
      if (roles.length === 0) {
        // Corporate only allows employees
        setShowRadioButtons(false);
        setType("Employee");
      } else if (roles.length === 1) {
        // Corporate allows only one type - set it and hide radio buttons
        setType(roles[0] === "student" ? "Student" : "Employee");
        setShowRadioButtons(false);
      } else {
        // Corporate allows both types - show radio buttons but preserve user selection
        setShowRadioButtons(true);
        // Don't override the current user selection
      }
    } else {
      // No corporate configuration - show radio buttons and preserve user selection
      setShowRadioButtons(true);
      // Don't override the current user selection
    }
    setIsStaffDetailApiCall(true);
  };

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Mark the first render as completed
      return; // Exit without making the API call
    }
    if (edit) {
      // In edit mode, determine corporateType from URL parameter or default to current type
      // This prevents wrong data being fetched when corporate settings override the type state
      const editCorporateType = editType 
        ? (editType.toLowerCase() === "student" ? "school" : "corporate")
        : (type === "Student" ? "school" : "corporate");
        
      sendRequest(
        {
          url: "/api/v1/Staff/GetStaffDetails",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: sessionStorage.getItem("user"),
            mobileNumber: edit,
            corporateType: editCorporateType,
          },
        },
        authenticateUser
      );
    }

  }, [isStaffDetailApiCall]);



  const editPageFileViewHandler = () => {
    if (val) viewDocument(val);
  };

  const viewDocument = (file) => {
    let pdfWindow = window.open("");
    pdfWindow.document.write(
      "<html<head><title>" +
        "document" +
        "</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>"
    );
    file.split(",")[0].includes("pdf")
      ? pdfWindow.document.write(
          "<body><embed width='50%' height='50%' src='data:application/pdf;base64, " +
            encodeURI(file.split(",")[1]) +
            "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>"
        )
      : pdfWindow?.document.write(
          `<head><title>Document preview</title></head><body><img src="${file}" width="30%" height="50%" ></body></html >`
        );
  };

  // Reverse mapping: convert numeric class code to grade string
  const getClassFromCode = (code) => {
    const reverseMapping = {
      13: 'Playgroup', 14: 'PP1', 0: 'PP2',
      1: 'Grade 1', 2: 'Grade 2', 3: 'Grade 3', 4: 'Grade 4', 5: 'Grade 5',
      6: 'Grade 6', 7: 'Grade 7', 8: 'Grade 8', 9: 'Grade 9', 10: 'Grade 10',
      11: 'Grade 11', 12: 'Grade 12', 
      15: 'Class 1', 16: 'Class 2', 17: 'Class 3', 18: 'Class 4', 19: 'Class 5',
      20: 'Class 6', 21: 'Class 7', 22: 'Class 8', 23: 'Class 9', 24: 'Class 10'
    };

    // Convert from numeric code
    const numCode = typeof code === 'string' ? parseInt(code, 10) : code;
    return reverseMapping[numCode] || code;
  };

  // Populate the form with a single student record
  const populateFromRecord = (targetRecord) => {
    let otherDetails = JSON.parse(targetRecord.OtherDetails);
    areaInputRef.current.value = otherDetails.Area;
    cityInputRef.current.value = otherDetails.City;
    addressRef.current.value = otherDetails.Address;
    studentFirstNameRef.current.value = targetRecord.FirstName;
    studentLastNameRef.current.value = targetRecord.LastName;
    if (type !== "Student") {
      studentClassRef.current.value =
        targetRecord.MobileNumber.slice(countryCode.length);
      studentClassRef.current.disabled = true;
    }
    if (type === "Student") {
      const rawClassValue = otherDetails.Class;
      const classValue = getClassFromCode(rawClassValue);
      console.log(' Class prefill:', { raw: rawClassValue, converted: classValue });
      const classOption = classOptions.find(opt => opt.value === classValue);
      setSelectedClass(classOption || null);
      if (studentClassRef.current) {
        studentClassRef.current.value = classValue;
      }
      parentFirstNameRef.current.value = otherDetails.ParentFirstName;
      parentLastNameRef.current.value = otherDetails.ParentLastName;
      parentMobileNumberRef.current.value = otherDetails.ParentsMobileNumber;
      parentEmailRef.current.value = otherDetails?.ParentEmailAddress || "";
      parentMobileNumberRef.current.value =
        targetRecord.MobileNumber.slice(countryCode.length);
    }
    pickupLatLng = {
      lat: +targetRecord.PickupLL.split(",")[0],
      lng: +targetRecord.PickupLL.split(",")[1],
    };
    dropLatLng = {
      lat: +targetRecord.DropLL.split(",")[0],
      lng: +targetRecord.DropLL.split(",")[1],
    };
    studentpickupAddress = targetRecord.PickupPoint;
    studentdropAddress = targetRecord.DropPoint;
    staffImg = targetRecord.RiderImage;
    setVal(targetRecord.RiderImage);
    setPickupLocationValid(true);
    setDropLocationValid(true);
  };

  const authenticateUser = (data) => {
    const staffList = data.Staffdetails || [];
    if (staffList.length > 0) {
      riderData = staffList;

      let targetRecord = null;

      // Match by firstName + lastName from URL params
      // e.g. ?edit=254717265799&firstName=Stacy&lastName=Mary
      if (editFirstName && editLastName) {
        targetRecord = staffList.find(record =>
          record.FirstName?.toLowerCase() === editFirstName.toLowerCase() &&
          record.LastName?.toLowerCase() === editLastName.toLowerCase()
        );
      }

      // Fallback: match by mobile number
      if (!targetRecord && edit) {
        targetRecord = staffList.find(record =>
          record.MobileNumber === edit
        );
      }

      // Last resort: first record
      if (!targetRecord) {
        targetRecord = staffList[0];
      }

      populateFromRecord(targetRecord);
    }
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    sendRequest(
      {
        url: "/api/v1/Corporate/GetShuttleStop",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          corporateID: corpId,
        },
      },
      corporateStopDetails
    );
  }, [sendRequest]);



  const areaChangeHandler = () => {
    if (areaInputRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, areaError: "" }));
    }
    // else {
    //   valid = false;
    //   setError((prev) => ({ ...prev, areaError: "Please Enter valid area" }));
    // }
  };

  const cityChangeHandler = () => {
    if (cityInputRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, cityError: "" }));
    }
    // else {
    //   valid = false;
    //   setError((prev) => ({ ...prev, cityError: "Please Enter valid city" }));
    // }
  };



  const studentFirstNameChangeHandler = () => {
    if (studentFirstNameRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, studentFirstNameError: "" }));
    }
    //  else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     studentFirstNameError: "Please Enter valid first name",
    //   }));
    // }
  };

  const studentLastNameChangeHandler = () => {
    if (studentLastNameRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, studentLastNameError: "" }));
    }
    // else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     studentLastNameError: "Please Enter valid last name",
    //   }));
    // }
  };

  const classOptions = [
    { value: "Playgroup", label: "Playgroup" },
    { value: "PP1", label: "PP1" },
    { value: "PP2", label: "PP2" },
    { value: "Grade 1", label: "Grade 1" },
    { value: "Grade 2", label: "Grade 2" },
    { value: "Grade 3", label: "Grade 3" },
    { value: "Grade 4", label: "Grade 4" },
    { value: "Grade 5", label: "Grade 5" },
    { value: "Grade 6", label: "Grade 6" },
    { value: "Grade 7", label: "Grade 7" },
    { value: "Grade 8", label: "Grade 8" },
    { value: "Grade 9", label: "Grade 9" },
    { value: "Grade 10", label: "Grade 10" },
    { value: "Grade 11", label: "Grade 11" },
    { value: "Grade 12", label: "Grade 12" },
    { value: "Form 1", label: "Form 1" },
    { value: "Form 2", label: "Form 2" },
    { value: "Form 3", label: "Form 3" },
    { value: "Form 4", label: "Form 4" },
    { value: "Class 1", label: "Class 1" },
    { value: "Class 2", label: "Class 2" },
    { value: "Class 3", label: "Class 3" },
    { value: "Class 4", label: "Class 4" },
    { value: "Class 5", label: "Class 5" },
    { value: "Class 6", label: "Class 6" },
    { value: "Class 7", label: "Class 7" },
    { value: "Class 8", label: "Class 8" },
    { value: "Class 9", label: "Class 9" },
    { value: "Class 10", label: "Class 10" },
  ];

  const studentClassChangeHandler = (selectedOption) => {
    setSelectedClass(selectedOption);
    if (studentClassRef.current) {
      studentClassRef.current.value = selectedOption?.value || "";
    }
    if (selectedOption?.value) {
      valid = true;
      setError((prev) => ({ ...prev, studentClassError: "" }));
    }
    // else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     studentClassError: "Please Enter Valid Class",
    //   }));
    // }
  };

  const studentPhotoChangeHandler = (e) => {
    let studentPhotoPath = studentPhotoRef.current.value;
    if (
      studentPhotoPath.includes("jpg") ||
      studentPhotoPath.includes("jpeg") ||
      studentPhotoPath.includes("png")
    ) {
      valid = true;
      editPageImgFlag = false;
      // console.log(e.target.files.file.size);
      setError((prev) => ({ ...prev, studentPhotoError: "" }));
      const [file] = e.target.files;
      // originalFile = file;
      img = URL.createObjectURL(file);
      let imageName = studentPhotoPath.split("fakepath");
      img_placeHolder = imageName[1].split("\\");
      // console.log(imageName);
      setMyImg(img);
    }
    //  else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     studentPhotoError: "Photo must be of jpg/jpeg/png",
    //   }));
    // }
  };

  const ParentFirstNameChangeHandler = () => {
    if (parentFirstNameRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, parentFirstNameError: "" }));
    }
    // else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     parentFirstNameError: "Please Enter Valid first name",
    //   }));
    // }
  };

  const parentMobileChangeHandler = () => {
    if (parentMobileNumberRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, parentMobileNumberError: "" }));
    }
    //  else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     parentMobileNumberError: "Please Enter Valid Mobile number",
    //   }));
    // }
  };

  const parentLastNameChangeHanler = () => {
    if (parentLastNameRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, parentLastNameError: "" }));
    }
    // else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     parentLastNameError: "Please Enter Valid last name",
    //   }));
    // }
  };

  const parentEmailChangeHanlder = () => {
    if (parentEmailRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, parentEmailError: "" }));
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(
        parentEmailRef.current.value
      )
    ) {
      valid = false;
      setError((prev) => ({
        ...prev,
        parentEmailError: "Please Enter Valid email",
      }));
    }
  };

  const addressChangeHandler = () => {
    if (addressRef.current.value) {
      valid = true;
      setError((prev) => ({ ...prev, addressError: "" }));
    }
    // else {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     addressError: "Please Enter Valid address",
    //   }));
    // }
  };

  const resetClickHandler = () => {
    valid = false;
    formRef.current.reset();
    img_placeHolder = "Only Upload Jpg/Png/Jpeg";
    setPickupLocationValid(false);
    setDropLocationValid(false);
    studentpickupAddress = undefined;
    studentdropAddress = undefined;
    pickupLatLng = undefined;
    dropLatLng = undefined;
    // setError(defaultState);
  };

  const getAddress = useCallback(
    (type, addressValue, lat, lng) => {
      // console.log("data",addressValue, lat, lng);
      if (type === "pickup") {
        pickupLatLng = { lat: +lat, lng: +lng };
        studentpickupAddress = addressValue;
      } else {
        dropLatLng = { lat: +lat, lng: +lng };
        studentdropAddress = addressValue;
      }
    },
    [type]
  );

  const handleLocationValidityChange = useCallback((type, isValid) => {
    if (type === "pickup") {
      setPickupLocationValid(isValid);
      if (isValid) {
        setError((prev) => ({ ...prev, pickupStopError: "" }));
      }
    } else {
      setDropLocationValid(isValid);
      if (isValid) {
        setError((prev) => ({ ...prev, dropStopError: "" }));
      }
    }
  }, []);

  const submitCLickHandler = (event) => {
    let studentPhotoPath = studentPhotoRef.current.value;
    edit
      ? (studentPhotoPath = "dummy")
      : (studentPhotoPath = studentPhotoRef.current.value);
    // console.log(studentPhotoPath);
    event.preventDefault();
    if (!schoolNameRef.current.value) {
      valid = false;
      setError((prev) => ({
        ...prev,
        schoolNameError: "Please select School/Institute name",
      }));
    }
    if (!addressRef.current.value) {
      valid = false;
      setError((prev) => ({
        ...prev,
        addressError: "Please Enter Valid Address",
      }));
    }

    if (!cityInputRef.current.value) {
      valid = false;
      setError((prev) => ({
        ...prev,
        cityError: "Please Enter Valid City",
      }));
    }

    if (!areaInputRef.current.value) {
      valid = false;
      setError((prev) => ({
        ...prev,
        areaError: "Please Enter Valid Area",
      }));
    }
    if (!/^[a-zA-Z ]{1,15}$/.test(studentFirstNameRef.current.value)) {
      valid = false;
      setError((prev) => ({
        ...prev,
        studentFirstNameError: "Please Enter Valid First name",
      }));
    }
    if (!/^[a-zA-Z ]{1,15}$/.test(studentLastNameRef.current.value)) {
      valid = false;
      setError((prev) => ({
        ...prev,
        studentLastNameError: "Please Enter Valid Last name",
      }));
    }
    if (!studentClassRef.current.value || !/^[a-zA-Z0-9 ]{1,15}$/.test(studentClassRef.current.value)) {
      valid = false;
      setError((prev) => ({
        ...prev,
        studentClassError: "Class/Standard is required. Please select a valid class.",
      }));
    }

    // if (!studentPhotoPath) {
    //   valid = false;
    //   setError((prev) => ({
    //     ...prev,
    //     studentPhotoError: "photo can not be empty",
    //   }));
    // }
    // if (!(studentPhotoPath.includes("jpg") || studentPhotoPath.includes("jepg") || studentPhotoPath.includes("png"))) {
    //   valid = false;
    //   setError(prev => ({ ...prev, studentPhotoError: "Photo must be of jpg/jpeg/png" }));
    // }

    // Validation for Student type required fields
    if (type === "Student") {
      if (!/^[a-zA-Z ]{1,50}$/.test(parentFirstNameRef.current.value)) {
        valid = false;
        setError((prev) => ({
          ...prev,
          parentFirstNameError: "Parent First Name is required (letters only, max 50 characters)",
        }));
      }
      if (!/^[a-zA-Z ]{1,50}$/.test(parentLastNameRef.current.value)) {
        valid = false;
        setError((prev) => ({
          ...prev,
          parentLastNameError: "Parent Last Name is required (letters only, max 50 characters)",
        }));
      }
      if (!parentMobileNumberRef.current.value || parentMobileNumberRef.current.value.length < 7) {
        valid = false;
        setError((prev) => ({
          ...prev,
          parentMobileNumberError: "Parent Mobile Number is required (minimum 7 digits)",
        }));
      }
      // Validate Pickup Stop - must be selected from autocomplete/stop/drag
      if (!studentpickupAddress || studentpickupAddress.trim() === "") {
        valid = false;
        setError((prev) => ({
          ...prev,
          pickupStopError: "Pickup location is required. Please type and select from the suggestions.",
        }));
      } else if (!pickupLocationValid) {
        valid = false;
        setError((prev) => ({
          ...prev,
          pickupStopError: "Please select a pickup location from the Google Maps suggestions dropdown.",
        }));
      }
      // Validate Drop Stop - must be selected from autocomplete/stop/drag
      if (!studentdropAddress || studentdropAddress.trim() === "") {
        valid = false;
        setError((prev) => ({
          ...prev,
          dropStopError: "Drop location is required. Please type and select from the suggestions.",
        }));
      } else if (!dropLocationValid) {
        valid = false;
        setError((prev) => ({
          ...prev,
          dropStopError: "Please select a drop location from the Google Maps suggestions dropdown.",
        }));
      }
    }
    // console.log(error);
    if (valid) {
      let element = document.getElementsByClassName("header")[0];
      element.scrollIntoView({ behavior: "smooth", block: "end" });
      setFormIsValid(true);
      setError(false);
    }
    // console.log(val);
  };

  const onCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    if (cropper.getCroppedCanvas().toDataURL().length > 20)
      staffImg = cropper.getCroppedCanvas().toDataURL();
    setVal(cropper.getCroppedCanvas().toDataURL());
  };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const submitCLicked = () => {
    // setIsSubmit(val);
    // setVal()
    if (!staffImg)
      getBase64(studentPhotoRef.current.files[0]).then(
        (data) => (staffImg = data)
      );
    // console.log(studentPhotoRef.current.files[0]);
    setMyImg(false);
  };

  const handleChange = (event) => {
    setType(event.target.value);
  };

  // Handle mode toggle between individual and bulk registration
  const handleModeToggle = (isBulkMode) => {
    const currentUrl = new URL(window.location);
    const params = currentUrl.searchParams;

    if (isBulkMode) {
      params.set('bulk', 'true');
    } else {
      params.delete('bulk');
    }

    // Navigate to the new URL with updated parameters
    window.location.href = currentUrl.toString();
  };

  // If bulk parameter is present, render bulk upload component
  if (bulk === "true") {
    return (
      <BulkUpload
        type={type}
        corpId={corpId}
        corpName={corpName}
        loadingGif={loadingGif}
      />
    );
  }

  return (
    <React.Fragment>
      {isLoading && (
        <img
          src={loadingGif}
          alt="loading"
          style={{
            position: "absolute",
            top: "40%",
            left: "45%",
            height: "80px",
          }}
        />
      )}

      {myImg && (
        <div className="modalBackgroundForImageCrop">
          <div className="modalContainerForImageCrop">
            <Cropper
              src={myImg}
              style={{ height: 300, width: 300 }}
              initialAspectRatio={16 / 9}
              guides={false}
              crop={onCrop}
              ref={cropperRef}
            />
            <br />
            <p className="text">Resultant Image:</p>{" "}
            <div className="imageCrop-footer">
              {/* <div className="sub-footer"> */}
              <img id="asd" src={val} className="image" alt="cropped" />
              <button onClick={submitCLicked} className="imageCrop-submit">
                Submit
              </button>
            </div>
            {/* </div> */}
          </div>
        </div>
      )}

      <div className="header">
        <img src={little_image} alt="little pic" className="little-image" />
        <p className="student-header">
          {type === "Student" ? "STUDENT REGISTRATION" : "STAFF REGISTRATION"}
        </p>
        <ModeToggle
          isBulkMode={bulk === "true"}
          onToggle={handleModeToggle}
          disabled={isLoading}
        />
      </div>
      <br />
      {/* <br /> */}
      <form
        ref={formRef}
        onSubmit={submitCLickHandler}
        autoComplete="off"
        style={{
          height: type === "Student" ? "100vh" : "calc(100vh - 120px)",
        }}
      >
        <main>
          <div className="normal-data">
            <div className="student-school-details">
              {/* Radio option of corporate and students */}
              {showRadioButtons && (
                <RadioGroup
                  row
                  aria-label="shuttleFor"
                  name="shuttleFor"
                  style={{ display: "flex", gap: "35%" }}
                  value={type}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Student"
                    control={<Radio />}
                    label="Student"
                  />
                  <FormControlLabel
                    value="Employee"
                    control={<Radio />}
                    label="Employee"
                  />
                </RadioGroup>
              )}

              <h4 className="sub-header-title">
                {type === "Student"
                  ? "school / institute detail"
                  : "Corporate details"}
              </h4>
              {/* <label htmlFor="school-details" className="required">school / institute name</label> */}
              {/* <br /> */}
              <input
                type="text"
                readOnly
                value={corpName || ""}
                ref={schoolNameRef}
                className="tags"
              />
              {/* {error.schoolNameError && (
                <p className="error">{error.schoolNameError}</p>
              )} */}
            </div>
            <br />
            <div className="student-self-details">
              <h4 className="sub-header-title">
                {(type === "Student" ? "student " : "staff ") + "details"}
              </h4>
              <div className="sub-container">
                <div className="inputContainers">
                  {/* <label htmlFor="first-name" className="required">
                    first name
                  </label> */}
                  {/* <br /> */}
                  <input
                    type="text"
                    id="first-name"
                    className="tags"
                    ref={studentFirstNameRef}
                    onChange={studentFirstNameChangeHandler}
                    placeholder="Enter First Name"
                    maxLength="20"
                    tabIndex="1"
                  />
                  {/* {error.studentFirstNameError && (
                    <p className="error">{error.studentFirstNameError}</p>
                  )} */}
                  <br />
                  {/* <label htmlFor="student-photo" className="required">
                    student passport size photo
                  </label> */}
                  {/* <br /> */}
                  <div className="file-upload">
                    <span>{img_placeHolder}</span>
                    <input
                      type="file"
                      id="student-photo"
                      className="tags photo"
                      ref={studentPhotoRef}
                      onChange={studentPhotoChangeHandler}
                      placeholder="Only upload PNG & JPG file"
                      tabIndex="3"
                    />
                    <FiUpload className="logo" />
                    <BsEyeFill
                      className="logo eye"
                      onClick={editPageFileViewHandler}
                    />
                  </div>
                  {/* {error.studentPhotoError && (
                    <p className="error">{error.studentPhotoError}</p>
                  )} */}
                  {/* {edit && editPageImgFlag && <span onClick={editPageFileViewHandler} style={{ color: "grey", fontSize: "10px", position: "absolute", cursor: "pointer" }}>click to view</span>} */}
                </div>
                <div className="inputContainers">
                  {/* <label htmlFor="last-name" className="required">
                    Last name
                  </label> */}
                  {window.screen.width <= 768 && <br />}
                  <input
                    type="text"
                    id="last-name"
                    className="tags"
                    ref={studentLastNameRef}
                    onChange={studentLastNameChangeHandler}
                    placeholder="Enter Last Name"
                    maxLength="20"
                    tabIndex="2"
                  />
                  {/* {error.studentLastNameError && (
                    <p className="error">{error.studentLastNameError}</p>
                  )} */}
                  <br />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {/* <input
                      type="text"
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                      style={{ width: "25px", height: "25px" }} 
                    /> */}
                    {type !== "Student" && (
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <select
                          value={countryCode}

  //                         const handleChange = selectedOption => {
  //   setSelectedOption({ selectedOption })
  //     console.log(`Option selected:`, selectedOption)
  // }
  //                         // onChange={(e) => setCountryCode(e.target.value)
                          // }
                          onChange={(e) => {
                            const selectedCode = e.target.value;
                            setCountryCode(selectedCode);
                            valid = selectedCode === "254"; // Set valid to true if countryCode is 254
                          }}
                          style={{
                            width: "65px",
                            height: "30px",
                            border: "none",
                            background: "transparent",
                            outline: "none",
                            appearance: "none",
                            fontSize: "16px",
                            cursor: "pointer",
                            // paddingRight: "15px",
                            padding: "5px 10px",
                          }}
                        >
                          <option value="91">91</option>
                          <option value="254">254</option>
                        </select>
                        {/* Down Arrow */}
                        <span
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                            fontSize: "12px",
                          }}
                        >
                          ▼
                        </span>
                      </div>
                    )}

                    <Select
                      id="student-class"
                      className="tags"
                      options={classOptions}
                      value={selectedClass}
                      onChange={studentClassChangeHandler}
                      placeholder={
                        type === "Student"
                          ? "Enter Students class"
                          : "Enter Mobile Number"
                      }
                      tabIndex="4"
                      isSearchable={true}
                      isClearable={true}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '30px',
                          height: '30px',
                          fontSize: '14px',
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: '30px',
                          padding: '0 8px',
                        }),
                        input: (base) => ({
                          ...base,
                          margin: '0px',
                        }),
                        indicatorsContainer: (base) => ({
                          ...base,
                          height: '30px',
                        }),
                      }}
                    />
                    <input
                      type="hidden"
                      ref={studentClassRef}
                      value={selectedClass?.value || ""}
                    />

                  </div>
                  {error.studentClassError && (
                    <p className="error">{error.studentClassError}</p>
                  )}
                </div>
              </div>
            </div>
            <br />
            {type === "Student" && (
              <div className="parent-details">
                <h4 className="sub-header-title">Parent Details</h4>
                <div className="sub-container">
                  <div className="inputContainers">
                    <input
                      type="text"
                      id="first-name"
                      className="tags requi"
                      ref={parentFirstNameRef}
                      onChange={ParentFirstNameChangeHandler}
                      placeholder="Enter Parent's First Name"
                      maxLength="20"
                      tabIndex="5"
                    />
                    {error.parentFirstNameError && (
                      <p className="error">{error.parentFirstNameError}</p>
                    )}
                    <br />
                    <div style={{ display: "flex" }}>
                      {/* <select
                        value={countryCode}
                        onChange={(e) => setCountryCode(e.target.value)}
                        style={{
                          width: "50px",
                          height: "30px",
                          border: "none", // Removes the default border
                          background: "transparent", // Makes the background transparent
                          outline: "none", // Removes the focus outline
                          appearance: "none", // Hides default system styling
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        <option value="91">91</option>
                        <option value="254">254</option>
                      </select> */}
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <select
                          value={countryCode}
                          // onChange={(e) => setCountryCode(e.target.value)}
                          onChange={(e) => {
                            const selectedCode = e.target.value;
                            setCountryCode(selectedCode);
                            valid = selectedCode === "254"; // Set valid to true if countryCode is 254
                          }}
                          style={{
                            width: "65px",
                            height: "30px",
                            border: "none",
                            background: "transparent",
                            outline: "none",
                            appearance: "none",
                            fontSize: "16px",
                            cursor: "pointer",
                            // paddingRight: "15px",
                            padding: "5px 10px",
                          }}
                        >
                          <option value="91">91</option>
                          <option value="254">254</option>
                        </select>
                        {/* Down Arrow */}
                        <span
                          style={{
                            position: "absolute",
                            right: "14px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                            fontSize: "12px",
                          }}
                        >
                          ▼
                        </span>
                      </div>

                      <input
                        type="number"
                        id="mobile-name"
                        className="tags"
                        ref={parentMobileNumberRef}
                        onChange={parentMobileChangeHandler}
                        placeholder="Enter Parent's Mobile Number"
                        autoComplete="off"
                        tabIndex="7"
                      />
                      {error.parentMobileNumberError && (
                        <p className="error">{error.parentMobileNumberError}</p>
                      )}
                    </div>

                    <br />
                  </div>
                  <div className="inputContainers">
                    <input
                      type="text"
                      id="last-name"
                      className="tags"
                      ref={parentLastNameRef}
                      onChange={parentLastNameChangeHanler}
                      placeholder="Enter Parent's Last Name"
                      maxLength="20"
                      tabIndex="6"
                    />
                    {error.parentLastNameError && (
                      <p className="error">{error.parentLastNameError}</p>
                    )}
                    <br />
                    <input
                      type="email"
                      id="email-address"
                      className="tags"
                      ref={parentEmailRef}
                      onChange={parentEmailChangeHanlder}
                      placeholder="Enter Email Address"
                      maxLength="30"
                      tabIndex="8"
                    />
                    {/* {error.parentEmailError && (
                      <p className="error">{error.parentEmailError}</p>
                    )} */}
                  </div>
                </div>
              </div>
            )}
            <div className="address-details">
              <h4 className="sub-header-title">Address Details</h4>
              <input
                type="text"
                id="address"
                className="tags address-line"
                ref={addressRef}
                onChange={addressChangeHandler}
                placeholder="Enter Address Line"
                maxLength="100"
                tabIndex="9"
              />
              {/* {error.addressError && (
                <p className="error">{error.addressError}</p>
              )} */}
              <br />
              <div className="sub-container">
                <div className="inputContainers">

                  <div>
                    <input
                      type="text"
                      className="tags"
                      ref={cityInputRef}
                      placeholder="Enter City"
                      onChange={cityChangeHandler}
                      tabIndex="12"
                    />
                    {/* {error.cityError && (
                      <p className="error">{error.cityError}</p>
                    )} */}

                  </div>
                </div>
                {window.screen.width <= 768 && <br />}
                <div className="inputContainers">
                  <input
                    type="text"
                    className="tags"
                    ref={areaInputRef}
                    placeholder="Enter Area"
                    onChange={areaChangeHandler}
                    tabIndex="11"
                  />
                  {/* {error.areaError && (
                    <p className="error">{error.areaError}</p>
                  )} */}
                  <br />

                </div>
              </div>
            </div>
          </div>
          {window.screen.width <= 768 && <br />}
          <div className="location-data">
            <Address
              stops={stops}
              addressEntered={getAddress}
              onLocationValidityChange={handleLocationValidityChange}
              type={type}
              edit={edit}
              riderData={riderData}
              corpName={corpName}
              pickupStopError={error.pickupStopError}
              dropStopError={error.dropStopError}
            />
          </div>
        </main>
        <div>
          <input type="submit" value="Submit" className="submit button" />
          <input
            type="button"
            value="Reset"
            className="reset button"
            onClick={resetClickHandler}
          />
        </div>
      </form>
      <div className="copyright">
        <div>
          <p>
            <span style={{ fontSize: "13px" }}>&#169;</span>
            <span className="year">{new Date().getFullYear()}</span>{" "}
            <span className="lFirst">L</span>
            <span className="i">i</span>
            <span className="tFirst">t</span>
            <span className="tSecond">t</span>
            <span className="lSecond">l</span>
            <span className="e">e</span>
          </p>
        </div>
      </div>
      {/* {console.log("val",img)} */}
      {formIsValid && (
        <Modal
          corpId={corpId}
          corpName={corpName}
          type={type}
          myOriginalFile={staffImg}
          pickupLatLng={pickupLatLng}
          dropLatLng={dropLatLng}
          address={addressRef.current.value}
          pickupStop={studentpickupAddress}
          dropStop={studentdropAddress}
          studentPhoto={staffImg}
          schoolname={schoolNameRef.current.value}
          studentfirstname={studentFirstNameRef.current.value}
          studentlastname={studentLastNameRef.current.value}
          studentclass={studentClassRef.current.value}
          parentfirstname={parentFirstNameRef?.current?.value}
          parentlastname={parentLastNameRef?.current?.value}
          parentmobilenumber={parentMobileNumberRef?.current?.value}
          parentemailaddress={parentEmailRef?.current?.value}
          area={areaInputRef.current.value}
          city={cityInputRef.current.value}
          closeCLickHandler={() => setFormIsValid(false)}
          countryCode={countryCode}
          edit={edit}
          qrcode={qrcode || edit}
        />
      )}
    </React.Fragment>
  );
}

export default App;
